import React, { useState, useEffect } from "react"
import { Container, Col } from "react-bootstrap"
import { ChartExample } from "../../Components/Admin/Overview"
import { SidemenuComponent } from "../../Components/Admin/Sidemenu"
import { MobChartExample } from "../../Components/Admin/MobileOverView"
import { DeliveryChartExample } from "../../Components/Admin/DeliveryOverview"
import { MobDeliveryChartExample } from "../../Components/Admin/MobileOverViewDelivery"
const AdminOverview = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Perform an initial check
    handleResize()

    // Listen for resize events
    window.addEventListener("resize", handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <Container fluid className="px-0">
      <Col lg="10" sm="12" className="px-0">
        {isMobile ? <MobDeliveryChartExample /> : <DeliveryChartExample />}
      </Col>
    </Container>
  )
}
export default AdminOverview
